import { faList } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from '@tanstack/react-router'
import type { ReactElement } from 'react'
import { useState } from 'react'
import {
  Button,
  ButtonVariation
} from '~/components/Global/Interactions/Button'
import { ApplicationsList } from '~/domains/applications/components/ApplicationsList'
import { useDashboardContext } from '~/domains/dashboard/context/DashboardContext'
import type { DashboardBlockLayoutProps } from '~/domains/dashboard/types'
import { OffersAutocomplete } from '~/domains/offers/components/OffersAutocomplete'
import { DashboardBlockLayout } from '../../DashboardBlock/DashboardBlockLayout'

export const LastApplicationsBlock = (
  props: DashboardBlockLayoutProps
): ReactElement => {
  const { userIds, isUserIdsLoading, agencyId } = useDashboardContext()
  const navigate = useNavigate()
  const [selectedOfferId, setSelectedOfferId] = useState<string | null>(null)

  const filters = selectedOfferId
    ? {
        offerId: Number.parseInt(selectedOfferId, 10),
        isCompleted: false,
        ...(agencyId && { agencyId })
      }
    : { userId: userIds, isCompleted: false, ...(agencyId && { agencyId }) }

  const actions = (
    <>
      <Button
        variation={ButtonVariation.Neutral}
        buttonSize="extraSmall"
        onClick={() => navigate({ to: '/applications' })}
      >
        <FontAwesomeIcon icon={faList} />
        Voir toutes les candidatures
      </Button>
      <OffersAutocomplete
        userIds={userIds}
        ids={selectedOfferId ? [selectedOfferId] : undefined}
        agencyId={agencyId ?? undefined}
        onChange={(value) => setSelectedOfferId(value || null)}
        extraSmall
      />
    </>
  )

  return (
    <DashboardBlockLayout {...props} actions={actions}>
      <ApplicationsList filters={filters} filtersLoading={isUserIdsLoading} />
    </DashboardBlockLayout>
  )
}
